module.exports = __webpack_public_path__ + "img/9788990028433.a25eaec6.jpg";